<template>
  <div>
    <div class="elevation-2 px-6 py-4 mb-4">
      Rawdata: {{ rdLen | brNum }} bytes, from pointer
      {{ startPointer | ptr }} to {{ endPointer | ptr }}
    </div>

    <v-expansion-panels accordion multiple focusable hover tile>
      <v-expansion-panel v-for="(frame, i) in frames" :key="i">
        <v-expansion-panel-header>
          <div class="h-row">
            <div class="grow-0" style="width: 150px">
              Frame {{ (i + 1) | pad(2) }}: {{ frame.type }}
            </div>
            <div style="width: 120px" class="text-right pr-6">
              ({{ frame.length }} bytes)
            </div>
            <div>
              {{ frame | shortDesc }}
            </div>
            <v-spacer />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="noPaddingExpansionPanel">
          <LapseTable :value="frame.payload" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import _ from 'lodash'
import Slicer from 'horus-parser/src/Slicer'
import brush from 'brush'

import { dt, brNum } from 'oderon-commons/src/formatters'

export default {
  components: {
    LapseTable: require('./LapseTable').default
  },
  props: {
    hb: {}
  },
  computed: {
    strRawdata() {
      let m = _.find(this.hb.measures, { measureType: 'raw_data' })
      if (m) return m.rawContents
      else return null
    },
    frames() {
      return this.parse().frames
    },
    rdLen() {
      return (this.strRawdata || '').length / 2
    },
    startPointer() {
      return this.hb.originalLastPointer
    },
    endPointer() {
      return this.hb.summary.endPointer
    }
  },
  methods: {
    parse() {
      if (this.strRawdata == null) return []

      let bytes = brush.hexToBytes(this.strRawdata),
        slicer = new Slicer(bytes, {
          startPointer: 0,
          keepBytesInFrames: true,
          keepBytesInLapses: true,
          lastFwVersion: this.hb.firmwareVersion,
          // eslint-disable-next-line
          logFn: console.log
        })

      this.parsedData = slicer.slice()

      // Ajusta cada frame para ter o .payload e o .bytes
      this.parsedData.frames.forEach(f => {
        if (f.type == 'event') f.payload = f.event
        if (f.type == 'header') f.payload = f.header
        if (f.type == 'footer') f.payload = f.footer
        if (f.type == 'lapses') f.payload = f.lapses
        if (f.type == 'garbage') f.payload = {}

        if (f.type != 'lapses') f.payload.bytes = f.bytes
      })

      return this.parsedData

      // if ( this.parsedData.remaining > 0 ) {
      //   let startIndex = this.parsedData.stoppedAt,
      //       endIndex   = bytes.length

      //   this.parsedData.frames.push({
      //     startIndex, endIndex,
      //     bytes   : bytes.slice(startIndex, endIndex),
      //     length  : endIndex - startIndex,
      //     type    : 'remaining'
      //   })
      // }

      // Se algum frame for do tipo "lapses", busca o
      // primeiro frame anterior a ele com tipo "header"
      // e seta nele, para poder calcular timestamp dos
      // lapsos.
      // let frames = this.parsedData.frames
      // _.forEach(frames, (f, idx) => {
      //   if ( f.type != 'lapses' ) return
      //   f.prevHeaderFrame = _.findLast(frames, {type: 'header'}, idx)

      //   let start = _.get(f.prevHeaderFrame, 'header.timestamp')

      //   _.forEach(f.lapses, (lapse, j) => {
      //     lapse.lapseIndex = `${j} (start + ${sDuration(j)})`
      //     if ( start != null ) {
      //       lapse.timestamp = moment(start).add(j, 's').toDate()
      //     }
      //   })
      // })
    }
  },
  filters: {
    pad(x, n) {
      return _.padStart(x, n, '0')
    },

    shortDesc(f) {
      if (f.type == 'header') {
        return `${dt(f.header.timestamp)} ─ ${f.header.driverId}`
      } else if (f.type == 'footer') {
        return `${dt(f.footer.timestamp)}`
      } else if (f.type == 'event') {
        return `${dt(f.event.timestamp)} ─ ${f.event.operationType} ${f.event
          .log || ''}`
      } else if (f.type == 'lapses') {
        return f.lapses.length + ' lapses'
      }
    },

    ptr(x) {
      if (x == null) return '-'
      return `${brNum(x)} (0x${brush.toHexString(x)})`
    }
  }
}
</script>

<style>
.noPaddingExpansionPanel > * {
  padding-top: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}
</style>
